import { adminHttpClient } from '../../commons/adminHttpClient'

const getFileUrl = (filename: string): Promise<string> => {
  return adminHttpClient.get(`/files/download?filename=${filename}`)
}

export default getFileUrl
